var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details",class:("details--" + _vm.title)},[_c('p',{staticClass:"details__title"},[_c('strong',[_vm._v(_vm._s(_vm.titleFix)+":")])]),_vm._v(" "),_c('p',{staticClass:"details__text",class:_vm.title === '6_extra' ? 'details__extra' : false,domProps:{"innerHTML":_vm._s(_vm.info)}},[_vm._v(_vm._s(_vm.info)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a372f6f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/typo/Details.vue
// module id = 308
// module chunks = 1